import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '@/core/http'
import { Response } from '@/core'
import { GetPackageInfoParams } from './package.api.types'
import { PackageInfo } from './package.types'
import { bookingEndpoints } from './package.api.booking'
import { ticketsEndpoints } from './package.api.tickets'
import { hotelsEndpoints } from './package.api.hotels'
import { flightsEndpoints } from './package.api.flights'
import { insuranceEndpoints } from './package.api.insurance'
import { promoCodeEndpoints } from './package.api.promoCode'
import { addonsEndpoints } from './package.api.addons'

export const packageApi = createApi({
  reducerPath: 'packageApi',
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    getPackageInfo: builder.query<Response<PackageInfo>, GetPackageInfoParams>({
      query: ({ sessionId }) => ({
        url: '/package/info',
        method: 'get',
        params: { sessionId },
      }),
    }),
    ...ticketsEndpoints(builder),
    ...hotelsEndpoints(builder),
    ...flightsEndpoints(builder),
    ...insuranceEndpoints(builder),
    ...promoCodeEndpoints(builder),
    ...bookingEndpoints(builder),
    ...addonsEndpoints(builder),
  }),
})

export const {
  useGetPackageInfoQuery,
  useLazyGetPackageInfoQuery,

  // tickets
  useTicketListQuery,
  useLazyTicketListQuery,
  usePreSelectTicketMutation,
  useAddTicketMutation,
  useRemoveTicketMutation,

  //addons
  useGetAddonsListQuery,
  useLazyGetAddonsListQuery,
  useAddAddonsMutation,
  useRemoveAddonsMutation,

  // hotels
  useHotelListMutation,
  useRemoveHotelMutation,
  useSaveHotelSearchParamsMutation,
  useGetHotelRoomsMutation,
  useAddHotelMutation,

  // flights
  useSaveFlightSearchParamsMutation,
  useGetFlightListMutation,
  useGetFlightUpgradesMutation,
  useAddFlightMutation,
  useRemoveFlightMutation,

  // insurance
  useAddInsuranceMutation,

  // promo code
  useApplyPromoCodeMutation,
  useRemovePromoCodeMutation,

  // shipment
  useShipmentSuggestionMutation,

  // booking
  useVerifyCartQuery,
  useLazyVerifyCartQuery,
  usePaymentIntentMutation,
  usePackagePreBookMutation,
  usePackageBookingMutation,
  useSecurePackageBookingMutation,
  useBookAffirmMutation,
  useLazyGetOrderStatusQuery,
  useUpdateAnalyticsStatusMutation,
} = packageApi

export default packageApi.reducer
